import React from "react";
// import "./CreateApplicationModal.css";
import { Modal } from "react-bootstrap";
import useCreateApplicationModal from "../../customHooks/CreateApplicationModal/useCreateApplicationModal";

const CreateApplicationModal = ({
  show,
  onHide,
  id,
  selectedApplication,
  fetchApplications,
}) => {
  const {
    formData,
    handleChange,
    setFormData,
    handleBlur,
    handleSubmit,
    renderErrorMessage,
  } = useCreateApplicationModal({
    id,
    selectedApplication,
    onHide,
    fetchApplications,
  });

  return (
    <Modal
      show={show}
      onHide={() => {
        onHide();
        setFormData({ sName: "", sDescription: "", iLimit: "" });
      }}
      size="lg"
    >
      <Modal.Header closeButton>
        <h1 className="font-bold text-xl">
          {id ? "Update Feature" : "Create Feature"}
        </h1>
      </Modal.Header>
      <Modal.Body>
        <div className="bg-[#f9fafb] p-[15px]">
          {/* Back button and add new feature text*/}
          {/* <div className="flex justify-between py-3 topheader rounded-lg">
            <h1 className="title">Add New Feature</h1>
            <button onClick={() => navigate("/features")} className="back">
              <IoArrowBackCircle size={20} /> Back
            </button>
          </div> */}
          <form onSubmit={handleSubmit}>
            <div className="form-box">
              <div className="form-section">
                <div className="form-group">
                  <label htmlFor="sName">
                    Application Name <span className="red">*</span>
                  </label>
                  <input
                    type="text"
                    name="sName"
                    id="sName"
                    value={formData.sName}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    placeholder="Enter Application Name"
                  />
                  {renderErrorMessage("sName") && (
                    <div className="text-left text-small  color_red inputErrorSection">
                      {renderErrorMessage("sName")}
                    </div>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="sDescription">
                    Application Description <span className="red">*</span>
                  </label>
                  <textarea
                    id="sDescription"
                    name="sDescription"
                    value={formData.sDescription}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Enter Application Description"
                    rows={8}
                  ></textarea>
                  {renderErrorMessage("sDescription") && (
                    <div className="text-left text-small  color_red inputErrorSection">
                      {renderErrorMessage("sDescription")}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <button type="submit" className="save-button">
              Save
            </button>
          </form>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CreateApplicationModal;
